module.exports = __webpack_public_path__ + "static/media/bg_residencia.7c91272f.png";